/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Excludeblockchain1Inputs */

const id_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecualikan Blockchain/NFT`)
};

const ms_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecualikan Blockchain/NFT`)
};

const da_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udeluk Blockchain/NFT`)
};

const de_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT ausschließen`)
};

const en_us2_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude Blockchain/NFT`)
};

const es_es2_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Blockchain/NFT`)
};

const es_mx2_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Blockchain/NFT`)
};

const fil_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibukod ang Blockchain/NFT`)
};

const fr_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclure Blockchain/NFT`)
};

const it_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escludi Blockchain/NFT`)
};

const hu_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT kizárása`)
};

const nl_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT uitsluiten`)
};

const no_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekskluder Blockchain/NFT`)
};

const pl_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyklucz Blockchain/NFT`)
};

const pt_br2_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Blockchain/NFT`)
};

const pt_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir Blockchain/NFT`)
};

const ro_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude Blockchain/NFT`)
};

const fi_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje pois Blockchain/NFT`)
};

const sv_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exkludera Blockchain/NFT`)
};

const vi_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại trừ Blockchain/NFT`)
};

const tr_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT'yi Hariç Tut`)
};

const cs_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyloučit Blockchain/NFT`)
};

const bg_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изключи Blockchain/NFT`)
};

const ru_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исключить Блокчейн/NFT`)
};

const uk_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виключити Blockchain/NFT`)
};

const ar_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استبعاد Blockchain/NFT`)
};

const hi_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT को छोड़ें`)
};

const th_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่รวม Blockchain/NFT`)
};

const ja_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockchain/NFT を除外`)
};

const zh_cn2_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排除区块链/NFT`)
};

const zh_hant1_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排除區塊鏈/NFT`)
};

const ko_search_checkboxes_excludeblockchain1 = /** @type {(inputs: Search_Checkboxes_Excludeblockchain1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블록체인/NFT 제외`)
};

/**
* | output |
* | --- |
* | "Exclude Blockchain/NFT" |
*
* @param {Search_Checkboxes_Excludeblockchain1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_excludeblockchain1 = /** @type {((inputs?: Search_Checkboxes_Excludeblockchain1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Excludeblockchain1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "ms") return ms_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "da") return da_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "de") return de_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "fil") return fil_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "fr") return fr_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "it") return it_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "hu") return hu_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "nl") return nl_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "no") return no_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "pl") return pl_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "pt") return pt_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "ro") return ro_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "fi") return fi_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "sv") return sv_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "vi") return vi_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "tr") return tr_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "cs") return cs_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "bg") return bg_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "ru") return ru_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "uk") return uk_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "ar") return ar_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "hi") return hi_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "th") return th_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "ja") return ja_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_excludeblockchain1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_excludeblockchain1(inputs)
	return ko_search_checkboxes_excludeblockchain1(inputs)
});
export { search_checkboxes_excludeblockchain1 as "search.checkboxes.excludeBlockchain" }